import React from 'react';

import Loader from '../Loader/Loader';

const env = require("../../config.js").default;

class LoaderView extends React.Component {
  constructor(props){
    super(props)
    this.state = {};
    this.state.style = {};
  }
  componentWillMount(){
    this.setState({style: this.props.style});
  }
  componentDidMount(){
    const $ = window.$
    document.title = env.APP_NAME;
    /*$("#loaderContainer").height($("#conteiner_loader").height() - $("#PartsFinderTitle").outerHeight(true))
    $(".background_aggiornamento").height($("#loaderContainer").height())*/

  }
  componentWillReceiveProps(nextProps){
    const $ = window.$
    this.setState({ style: nextProps.style });
    /*$("#loaderContainer").height($("#conteiner_loader").height() - $("#PartsFinderTitle").outerHeight(true))
    $(".background_aggiornamento").height($("#loaderContainer").height())*/
  }
  render(props) {
    const { text } = this.props;
    const { url } = this.props;
    return (
      <div className="content_testo show_loader" id="conteiner_loader" /*style={this.state.style !== undefined ? this.state.style : {} }*/>
				<div id="content-core">
					<div id="loaderContainer" style={{alignItems: "center"/*, height: (this.state.style !== undefined && this.state.style.height !== undefined && this.state.style.height !== null ? this.state.style.height : "calc(100vh - var(--header-height) - var(--footer-height))")*/}}>
						<div className="text-center content_error">
              <Loader text={text} url={url}></Loader>
            </div>
          </div>
				</div>
      </div>
    )
  }
}

export default LoaderView;
